import script from "./ProfilePhotoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePhotoModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilePhotoModal.vue?vue&type=style&index=0&id=5d419692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d419692"]])

export default __exports__